import React from "react";
import Navigation from "../components/Navigation";
import { CopyToClipboard } from 'react-copy-to-clipboard';

const Contact = () => {
  return (
    <div className="contact">
      <Navigation />
      <div className="contactContent">
        <div className="header"></div>
        <div className="contactBox">
          <h1>Contactez-moi</h1>
          <ul>
            <li>
              <i className="fa fa-map-marker"></i>
              <span>Kinshasa</span>
            </li>
            <li>
              <i className="fa fa-mobile"></i>
              <CopyToClipboard text="+243 973913544">
                <span className="clickInput" onClick={()=>{alert("Téléphone copié !");}}>+243 973913544</span>
              </CopyToClipboard>
            </li>
            <li>
              <i className="fa fa-envelope"></i>
              <CopyToClipboard text="jkamanda062@gmail.com">
                <span className="clickInput" onClick={()=>{alert("Mail copié !");}}>jkamanda062@gmail.com</span>
              </CopyToClipboard>
            </li>
          </ul>
        </div>
        <div className="socialNetwork">
            <ul>
                <a href="https://www.linkedin.com/in/junior-kamanda-20a68622a/" target="_blank" rel="noopener noreferrer">
                    <h4>LinkedIn</h4>
                    <i className="fa fa-linkedin"></i>
                </a>
                <a href="https://github.com/JunKamanda" target="_blank" rel="noopener noreferrer">
                    <h4>Github</h4>
                    <i className="fa fa-github"></i>
                </a>
                <a href="http://www.google.com" target="_blank" rel="noopener noreferrer">
                    <h4>Twitter</h4>
                    <i className="fa fa-twitter"></i>
                </a>
                <a href="https://web.facebook.com/junior.kaniynda.7/" target="_blank" rel="noopener noreferrer">
                    <h4>Facebook</h4>
                    <i className="fa fa-facebook"></i>
                </a>
            </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
